<template>
    <b-col cols="12"
           lg="9"
           id="section_main"
           class="section-main">
        <check-fnwallet v-if="!hasPacket"></check-fnwallet>
        <futurocoins-from-mining v-if="hasPacket"></futurocoins-from-mining>
        <form id="wallet_otp"
              class="wallet-otp"
              @submit.prevent="validate">
            <b-row class="wallet-preferences-inner">
                <b-col lg="12">
                    <h3 class="section-main-title settings-header instruction-header">
                        <span style="text-transform: none">
                            How to configure One Time Password security?
                        </span>
                        <span class="fr desktop-only">
                            <span style="text-transform: none">Instructions/Manual: </span>
                              <ul class="otp-instruction-lang">
                                <li v-for="(link, lang) in instructions"
                                    style="margin-left: 6px;">
                                    <a :href="link" target="_blank">{{ lang }}</a>
                                </li>
                            </ul>
                        </span>
                    </h3>
                    <h3 class="section-main-title mobile-only instruction-header no-border"
                        style="margin-bottom: 30px">
                        <span style="text-transform: none">Instructions/Manual: </span>
                        <ul class="otp-instruction-lang">
                            <li v-for="(link, lang) in instructions"
                                style="margin-left: 6px;">
                                <a :href="link" target="_blank">{{ lang }}</a>
                            </li>
                        </ul>
                    </h3>
                    <div class="instruction">
                        <div class="instruction-item">
                            <div class="instruction-item--number currency-color">1</div>
                            <div class="instruction-item--content">
                                <p>Install Google Authenticator on your smartphone.<br class="desktop-only">You will easily find in Google Play/App Store and it is free to install and use.</p>
                                <ul class="stores">
                                    <li>
                                        <a href="https://itunes.apple.com/us/app/google-authenticator/id388497605"
                                           target="_blank">
                                            <div class="store-icon app-store"></div> App store
                                        </a>
                                    </li>
                                    <li>
                                        <a href="https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2"
                                           target="_blank">
                                            <div class="store-icon google-play"></div> Google play
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div class="instruction-item">
                            <div class="instruction-item--number currency-color">2</div>
                            <div class="instruction-item--content">
                                <p>Choose your smartphone, scan the bar code or type<br class="desktop-only">your name and key within your Google Authenticator app.</p>

                                <div class="scan-code">
                                    <div class="qrcode">
                                        <p>Scan your code</p>
                                        <qrcode-vue :value="qrcode"></qrcode-vue>
                                    </div>
                                    <div class="copy">
                                        <p>OR just type your name and key</p>
                                        <p>
                                            <strong>Account name:</strong> {{ accountName }}_{{ username }}<br>
                                            <strong>Account key: </strong> {{ accountKey }}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="instruction-item">
                            <div class="instruction-item--number currency-color">3</div>
                            <div class="instruction-item--content">
                                <p>Check if your code from<br class="desktop-only">Google Authenticator app is valid.</p>
                            </div>
                        </div>
                    </div>
                    <h3 class="section-main-title no-border instruction-header checker-title">
                        <span style="text-transform: none">If the code is correct, the configuration will be completed and you never see this site again.</span>
                    </h3>
                    <div class="form-item form-item-check">
                        <div class="outer">
                            <input id="otp_checker"
                                   name="code"
                                   type="text"
                                   v-model="token"
                                   v-validate
                                   data-vv-rules="required"
                                   :disabled="progress">
                            <button class="button--primary"
                                    v-if="!progress">Check</button>
                            <button class="button--primary button--progress"
                                    v-if="progress"
                                    type="button">Check</button>
                        </div>
                        <p class="field-error--description" v-show="errors.has('code')">{{ errors.first('code') }}</p>
                    </div>
                </b-col>
            </b-row>
        </form>
    </b-col>
</template>

<script>
    import CheckFnwallet from './dashboard/CheckFnwallet.vue'
    import FuturocoinsFromMining from './dashboard/FuturocoinsFromMining.vue'
    import QrcodeVue from 'qrcode.vue'

    export default {
        dependencies: ['api', 'popup', 'status', 'settings'],
        components: { CheckFnwallet, FuturocoinsFromMining, QrcodeVue },
        data() {
            return {
                accountName: 'FuturoNetwork',
                accountKey: '',
                code: '',
                instructions: {
                    EN: 'https://futurenet.club/download/SettingupGoogleAuthenticatoronFutureNet.club.pdf',
                    PL: 'https://futurenet.club/download/SettingupGoogleAuthenticatorpl.pdf'
                },
                token: '',
                progress: false
            }
        },
        computed: {
            hasPacket () {
                return this.$store.getters.user.position != 0;
            },
            qrcode () {
                return 'otpauth://totp/' + this.accountName + '?secret=' + this.accountKey;
            },
            username () {
                return this.$store.getters.user.login;
            },
        },
        methods: {
            validate () {
                this.$validator.validateAll().then(() => {
                    if (!this.errors.any()) {
                        this.submit();
                    }
                });
            },
            submit() {
                this.progress = true;

                this.$http.post(this.api.token.confirm, {
                    token: this.token
                }).then(response => {
                    this.$store.commit('setOtp');
                    this.settings.create();
                    this.settings.save();
                    this.progress = false;
                }, error => {
                    this.popup.show(error.data.errors[0].message);
                    this.progress = false;
                })
            }
        },
        mounted () {
            this.$store.commit('hideOtpPage')
            this.$http.get(this.api.user.settings.google).then(response => {
                this.accountKey = response.data.data.filter(function (obj) {
                    return obj.name === "GOOGLE_AUTHENTICATOR_SECRET";
                })[0]['value'];
            }, error => {
                this.popup.show(error.data.message);
            })
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../../../../assets/scss/_colors.scss';

    .section-main-title{
        margin-top: 28px;
    }

    .otp-instruction-lang{
        display: inline-block;
        vertical-align: baseline;
        margin: 0 0 0 12px;
        word-spacing: 4px;

        li{
            display: inline-block;
            width: 35px;
            line-height: 35px;
            height: 35px;
            background: $base2;
            text-align: center;
            color: $white;
            border-radius: 50%;
            cursor: pointer;

            a{
                color: $white;

                &:hover,
                &:focus{
                    text-decoration: none;
                }
            }
        }
    }

    .instruction-header{
        justify-content: space-between;
    }

    @media(max-width: 991px){
        .instruction-header{
            margin: 0;
        }
    }

    .instruction{
        padding-bottom: 20px;
        border-bottom: 1px solid $gray;
    }

    .instruction-item{
        position: relative;
        padding-top: 12px;
        padding-left: 40px;
    }

    .instruction-item--number{
        position: absolute;
        top: 0;
        left: 0;
        line-height: 40px;
        font-size: 46px;
        font-weight: bold;
        color: $base1;
    }

    .instruction-item--content{
        p{
            font-size: 12px;
            font-weight: bold;
            line-height: 1.2;
            margin: 0 0 11px;
        }
    }

    .stores{
        margin: 40px 0;

        li{
            &:not(:last-child){
                 margin-bottom: 12px;
            }

            a{
                color: $black;
                font-size: 12px;
                font-weight: bold;
            }
        }
    }

    .store-icon{
        display: inline-block;
        width: 36px;
        height: 36px;
        vertical-align: middle;
        margin-right: 16px;
        background-position: center;
        background-repeat: no-repeat;
    }

    .app-store{
        background-image: url('../../../../../assets/img/app-store.png');
    }

    .google-play{
        background-image: url('../../../../../assets/img/google-play.png');
    }

    .no-border{
        border: 0;
    }

    .scan-code{
        margin: 40px 0;
        word-spacing: 70px;

        >div{
            display: inline-block;
            word-spacing: normal;

            &.copy{
                 vertical-align: top;

                strong{
                    display: inline-block;
                    width: 100px;
                }
            }
        }
    }

    @media(max-width: 991px){
        .scan-code{
            word-spacing: normal;

            >div{
                display: block;

                &.qrcode{
                     margin-bottom: 40px;
                }
            }
        }

        .checker-title{
            text-align: center;
            margin: 15px 0;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/layout/partials/section/content/OtpContent.vue